import { motion, useInView } from 'framer-motion';
import { useRef, useState, useEffect } from 'react';
import { 
    pageVariants, 
    slideLeftUpVariants, 
    slideFromRightVariants,
    slideFromBelowVariants 
} from '../data/motionData';


const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth <= 500);
        };
        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);
        return () => window.removeEventListener('resize', checkIsMobile);
    }, []);
    return isMobile;
};

// Function for sliding from left and going up
export const AnimatedSection = ({ children, delay = 0 }) => {
    const ref = useRef(null);
    const isMobile = useIsMobile();
    const isInView = useInView(ref, { 
        once: true, 
        amount: 0.05, 
        margin: isMobile ? '0px 0px 150px 0px' : '0px'
    });
  
    return (
      <motion.div
        ref={ref}
        variants={pageVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        transition={{ delay }}
      >
        {children}
      </motion.div>
    );
};

// Function for sliding from left and going up
export const AnimatedSectionLeftUp = ({ children, delay = 0 }) => {
    const ref = useRef(null);
    const isMobile = useIsMobile();
    const isInView = useInView(ref, { 
        once: true, 
        amount: 0.05, 
        margin: isMobile ? '0px 0px 150px 0px' : '0px'
    });
  
    return (
      <motion.div
        ref={ref}
        variants={slideLeftUpVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        transition={{ delay }}
      >
        {children}
      </motion.div>
    );
};

// Function for sliding from right
export const AnimatedSectionFromRight = ({ children, delay = 0 }) => {
    const ref = useRef(null);
    const isMobile = useIsMobile();
    const isInView = useInView(ref, { 
        once: true, 
        amount: 0.05, 
        margin: isMobile ? '0px 0px 150px 0px' : '0px'
    });
  
    return (
      <motion.div
        ref={ref}
        variants={slideFromRightVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        transition={{ 
            delay,
            duration: 1.2,
            ease: "easeOut" 
        }}
      >
        {children}
      </motion.div>
    );
};

// Function for sliding from below with blur effect
export const AnimatedSectionFromBelow = ({ children, delay = 0 }) => {
    const ref = useRef(null);
    const isMobile = useIsMobile();
    const isInView = useInView(ref, { 
        once: true, 
        amount: 0.05, 
        margin: isMobile ? '0px 0px 150px 0px' : '0px'
    });
    
    return (
        <motion.div
        ref={ref}
        variants={slideFromBelowVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        transition={{ 
            delay,
            duration: 1.2,
            ease: "easeOut" 
        }}
        >
        {children}
        </motion.div>
    );
};